import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';

import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ExperienceSection from './components/ExperienceSection';
import PortfolioSection from './components/PortfolioSection';
import ContactSection from './components/ContactSection';
import LandingScreen from './components/LandingScreen';
import CustomCursor from './components/CustomCursor';
import SmoothScroll from './components/SmoothScroll';

import './App.css';

function App() {
  const [showLanding, setShowLanding] = useState(true);

  return (
    <div className="app-container relative">
      <CustomCursor />
      
      {/* Landing Screen - Fades out to reveal content */}
      <AnimatePresence>
        {showLanding && (
          <LandingScreen onComplete={() => setShowLanding(false)} />
        )}
      </AnimatePresence>

      {/* Main Content with Smooth Scroll */}
      {!showLanding && (
        <SmoothScroll>
          <main>
            <HeroSection />
            <AboutSection />
            <ExperienceSection />
            <PortfolioSection />
            <ContactSection />
          </main>
        </SmoothScroll>
      )}
    </div>
  );
}

export default App;